async function exportToWord(target,opt={}){         /* 1. 参数 */
  opt={
    fileName:'document.docx',
    orientation:'portrait',
    margins:{
      top: 720,       // 0.5英寸 = 720 twips
      right: 720,     // 0.5英寸
      bottom: 720,    // 0.5英寸
      left: 720       // 0.5英寸
    },
    extraCss:`
      body { 
        margin: 0; 
        padding: 0; 
        font-family: 'Microsoft YaHei', Arial, sans-serif;
        line-height: 1.4;
      }
      * { 
        box-sizing: border-box; 
      }
    `,
    callback: () => {},
    ...opt
  };

  /* 2. 保证依赖已加载 (unpkg→jsDelivr) */
  await loadLibs([
    {check:()=>window.htmlDocx,
     url:'https://unpkg.com/html-docx-js/dist/html-docx.js',
     fail:'https://cdn.jsdelivr.net/npm/html-docx-js/dist/html-docx.js'},
    {check:()=>window.saveAs,
     url:'https://unpkg.com/file-saver@2/dist/FileSaver.min.js',
     fail:'https://cdn.jsdelivr.net/npm/file-saver@2/dist/FileSaver.min.js'}
  ]);

  /* 3. 克隆目标 DOM */
  const origin=typeof target==='string'?document.querySelector(target):target;
  if(!origin) throw Error('exportToWord: target not found');
  const node=origin.cloneNode(true);

  /* 4. 内联图片 */
  await inlineAllImages(node);

  /* 5. 收集样式 */
  const styleHtml=[...document.querySelectorAll('style,link[rel="stylesheet"]')]
        .map(e=>e.outerHTML).join('')+(opt.extraCss?`<style>${opt.extraCss}</style>`:'');

  /* 6. 拼 HTML & 生成 docx */
  const full=`<!DOCTYPE html><html xmlns:o="urn:schemas-microsoft-com:office:office"
xmlns:w="urn:schemas-microsoft-com:office:word"
xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="utf-8">
${styleHtml}</head><body>${node.outerHTML}</body></html>`;

  const blob=htmlDocx.asBlob(full,{orientation:opt.orientation,margins:opt.margins});
  
  // 确保 saveAs 函数已加载
  if (typeof saveAs !== 'function') {
    const error = new Error('saveAs function not loaded');
    setTimeout(() => {
      opt.callback && opt.callback(false, error);
    }, 0);
    return blob;
  }
  
  try {
    saveAs(blob, opt.fileName);
    // saveAs 是同步操作，直接调用成功回调
    setTimeout(() => {
      opt.callback && opt.callback(true);
    }, 0);
  } catch (err) {
    // 如果 saveAs 失败，调用失败回调
    setTimeout(() => {
      opt.callback && opt.callback(false, err);
    }, 0);
  }
  
  return blob;
}

/* --------- 工具: 动态加载脚本，支持备用 URL --------- */
function loadLibs(arr){
  return Promise.all(arr.map(i=>new Promise((res,rej)=>{
    if(i.check()) return res();
    const s=document.createElement('script');s.src=i.url;
    s.onload=res;
    s.onerror=()=>{
        if(i.fail){
          const f=document.createElement('script');f.src=i.fail;
          f.onload=res;f.onerror=()=>rej(Error('加载失败:'+i.fail));
          document.head.appendChild(f);
        }else rej(Error('加载失败:'+i.url));
    };
    document.head.appendChild(s);
  })));
}

/* --------- 工具: 将网络图片转成 base64 --------- */
async function inlineAllImages(container){
  const imgs=[...container.querySelectorAll('img')];
  await Promise.all(imgs.map(async img=>{
    if(/^data:image\//i.test(img.src)) return;
    try{
      const r=await fetch(img.src,{mode:'cors'});
      const b=await r.blob();
      img.src=await new Promise(r2=>{const fr=new FileReader();
        fr.onload=()=>r2(fr.result);fr.readAsDataURL(b);});
    }catch(e){console.warn('图片内联失败',img.src,e);}
  }));
}

export default exportToWord;